import { Notification, isChatNotification } from 'types/notifications'

const getNotificationsForOrder = (orderNumber: string, notifications: Notification[]) => {
  return notifications.filter((val) => {
    return isChatNotification(val) && val.orderId === orderNumber
  })
}

export default getNotificationsForOrder
